import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth';
import { FullPageSpinner } from '@/shared/ui/Spinner';

import { routes } from './route-paths';

export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') return <FullPageSpinner />;
  if (status === 'anonymous') {
    return <Navigate to={routes.login} replace state={{ from: location }} />;
  }
  return <Outlet />;
}
